module.exports = __webpack_public_path__ + "static/media/ino_payment_unselected.ece328c9.svg";